import { useMemo } from 'preact/hooks';

const DefaultCTAColor = '#03A9F4';

// Source: https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)
function shadeHexColor(hex: string, percent: number) {
  const f = parseInt(hex.replace('#', ''), 16);
  const R = f >> 16;
  const G = (f >> 8) & 0x00ff;
  const B = f & 0x0000ff;
  const t = percent < 0 ? 0 : 255;
  const p = Math.abs(percent);

  const shadeR = Math.round((t - R) * p) + R;
  const shadeG = Math.round((t - G) * p) + G;
  const shadeB = Math.round((t - B) * p) + B;
  const shadeColor = 0x1000000 + shadeR * 0x10000 + shadeG * 0x100 + shadeB;
  const shadeColorString = shadeColor.toString(16).slice(1);

  return '#' + shadeColorString;
}

export function useCTAColor(baseColor: string | undefined) {
  return useMemo(() => {
    baseColor = baseColor || DefaultCTAColor;
    return [baseColor, shadeHexColor(baseColor, -0.25)];
  }, [baseColor]);
}
